import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-upload-aktualisieren';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenDokumentUploadAktualisierenEffects {

    DokumentUploadAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_UPLOAD_AKTUALISIEREN),
        mergeMap((x: ac.PostDokumentUploadAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentUploadAktualisieren(x.dokumentUploadAktualisierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentUploadAktualisierenErfolgreichAction(result, x.dokumentUploadAktualisierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentUploadAktualisierenFehlerAction(error, x.dokumentUploadAktualisierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumenteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumenteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumenteCommandService);
        }
        return this.service;
    }
}
